<div class="row mt-3">
<div class="col-md-10 offset-md-1 card-1">
  <div class="row">
    <div class="col-md-6 text-center">
      <carousel [itemsPerSlide]="1" [singleSlideOffset]="false" [noWrap]="true" [interval]="3000" [startFromIndex]="0">

        <slide>
             <img src="assets/img/new/download-app.png" alt="First slide" > 
        </slide>
        <slide>
             <img src="assets/img/new/download-app1.png" alt="Third slide" > 
        </slide>
        <slide>
          <img src="assets/img/new/download-app2.png" alt="Third slide" > 
        </slide>
        <slide>
          <img src="assets/img/new/download-app3.png" alt="Third slide" > 
        </slide>
        <slide>
          <img src="assets/img/new/download-app4.png" alt="Third slide" > 
        </slide>
        <slide>
          <img src="assets/img/new/download-app5.png" alt="Third slide" > 
     </slide>
    </carousel>
      
    </div>
    <div class="col-md-6  align-self-center">
      <h1 class="tex-center font65">Download </h1>
      <h3 class="tex-center font40">Our New App</h3>
      <h5 class="tex-center font35">FastSwiff Future POS</h5>
      <p style="text-align: justify; color: gainsboro;">Grow your business with the FastSwiff Merchant Application. Seamlessly accept payments and access all payment functionalities. Enjoy easy-to-use features such as point-of-sale transactions, QR or barcode scanning, in-store and online ordering, as well as phone orders. Take full advantage of FastSwiff's intuitive point-of-sale and order management capabilities. </p>
      <div class="row mt-4">
        <div class="col-6">
          <!-- <img src="assets/img/new/app-android-link.png" alt="android link"> -->
        </div>
        <div class="col-6">
          <!-- <a href="https://play.google.com/store/apps/details?id=com.xsilica.paygfuturepos" target="_blank" class="google-btn"><i class="fab fa-google-play "></i>  Download on <span>Google Play</span> </a> -->
        </div>
      </div>
    </div>
  </div>
 
</div>

  
   
</div>